import React, { Component } from "react";
import { onUnsubClick } from "../../../utils/helper";

class ZaFooter extends Component {
  render() {
    return (
      <div className="za_footer">
        <div className="unsub_text">
          <p>To unsubscribe, dial 135*997#</p>
          {/* <p>
            Go to{" "}
            <a className="unsub_link" href="https://bit.ly/3if1lzJ">
              https://bit.ly/3if1lzJ
            </a>{" "}
            to manage your content services.
          </p> */}
        </div>
        <div className="seperator">|</div>
        <a
          href="http://n.mobiosastro.com/za/tnc-mobioastro?offer=1"
          target="_blank"
        >
          Terms & Conditions
        </a>
      </div>
    );
  }
}

export default ZaFooter;



// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/zafooter.js